'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    getMinuteOfWeek: function getMinuteOfWeek(date) {
        var firstWeekday = getFirstWeekday(date);
        return date.diff(firstWeekday, 'minutes');
    }
};


function getFirstWeekday(date) {
    return date.isoWeekday() % 7 === 0 ? date.clone().startOf('d') : date.clone().startOf('isoWeek').add(-1, 'd');
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/helpers/Time.js
// module id = 379
// module chunks = 0